/* eslint-disable */
import React, { useEffect, useState, useRef } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import QualificationNameForm from './QualificationNameForm';
import { getAllQualificationTypesCombo, getQualificationNameListPagination, manageQualificationName, resetAllQualificationNameList } from '../actions/masterManagementAction';
import masterLabels from '../labels/master_en.json';
import commonLabels from '../../../common/labels/common_en.json';
import TablePagination from '../../../common/components/TablePagination';
import ConfirmationDialog from '../../../common/components/ConfirmationDialog';
import { toastr } from 'react-redux-toastr';
import Select from 'react-select';


const QualificationNameList = ({qualificationType}) => {
  let rowPerPage = 10;
  let [addQualificationName, setAddQualificationName] = useState('');
  let [qualificationNameToSearch, setQualificationNameToSearch] = useState(false);
  let [showModal, setShowModal] = useState(false);
  let [deleteQualificationName, setDeleteQualificationName] = useState(0);
  let [listCurrentPage, setListCurrentPage] = useState(0);
  let [qualificationTypeCode, setQualificationTypeCode] = useState('');
  let [searchMode, setSearchMode] = useState(false);
  const dispatch = useDispatch();
  const inputRef = useRef();

  useEffect(() => {
    dispatch(resetAllQualificationNameList());
    dispatch(getAllQualificationTypesCombo());
    qualificationType && setQualificationTypeCode(qualificationType)
   qualificationType ? dispatch(getQualificationNameListPagination(0, rowPerPage, qualificationType)):    dispatch(getQualificationNameListPagination(0, rowPerPage))


    // eslint-disable-next-line
  }, [])
  const searchQualName = (qualificationNameToSearch) => {
    setSearchMode(Number(new Date()));
    qualificationTypeCode && dispatch(getQualificationNameListPagination(0, rowPerPage, qualificationTypeCode, qualificationNameToSearch));
    !qualificationTypeCode && toastr.error(commonLabels.SEARCH_VALIDATION_ERROR);
  }

  const onQualificatioTypeChange = (e) => {
    setQualificationTypeCode(e.target.value);
    dispatch(getQualificationNameListPagination(0, rowPerPage, e.target.value, qualificationNameToSearch));
  }

  const manageQualType = (qualificationNameId) => {
    setShowModal(true);
    setDeleteQualificationName(qualificationNameId);
  }

  const activeQualType = (qualificationNameId, isActive) => {

    let qualificationNames = {
      qualificationNameDto: { "qualificationNameCode": qualificationNameId, "isActive": !isActive }
    };
    dispatch(manageQualificationName(qualificationNames, rowPerPage, listCurrentPage, qualificationTypeCode, qualificationNameToSearch));
  }

  const deleteQualType = (deleteQualificationName) => {
    setShowModal(false);
    let qualificationName = {
      qualificationNameDto: { "qualificationNameCode": deleteQualificationName, "isDeleted": true }
    };
    dispatch(manageQualificationName(qualificationName, rowPerPage, 0, qualificationTypeCode));
  }

  const { qualificationTypesCombo, qualificationNameListDetails, qualificationNamePageNoCounter } = useSelector((state) => state.masterManagementReducer, shallowEqual);
  let tableCounter = qualificationNamePageNoCounter + 1;


// Prepare options
const qualificationOptions = qualificationTypesCombo
  ?.filter(el => !el.isDeleted && el.isActive)
  .map(el => ({
    value: el.qualificationtypecode,
    label: el.qualificationtypename
  }));

// Get selected value from the code
const selectedQualification = qualificationOptions?.find(
  option => option.value === qualificationTypeCode
) || null;

  return addQualificationName ? (
    <div>
      <QualificationNameForm addQualificationname={addQualificationName} rowPerPage={rowPerPage} />
    </div>
  ) : (
    <div className="border border-light" style={{ width: "100%", padding: "20px" }}>
      <div className='form-group'>
        <div className='row'>
          <div className='col-md-3 mt-1'>
            <label className="font-weight-bold float-left">{masterLabels.qualificationNameList.Qualification_Type_Code_Field_Label}<span className="redColor">*</span></label>
            {/* <select
              className='form-select'
              name="qualificationType"
              onInput={onQualificatioTypeChange}
              ref={inputRef}
              value={qualificationTypeCode}
            >
              <option key={0} value="">{commonLabels.COMBO_SELECT}</option>
              {qualificationTypesCombo && qualificationTypesCombo.length > 0 && qualificationTypesCombo.filter(element => element.isDeleted == false && (element.isActive === true)).map((element, index) =>
                <option key={index} value={element.qualificationtypecode}>{element.qualificationtypename}</option>
              )}
            </select> */}
<br />
            <Select
  // className="form-select"
  name="qualificationType"
  options={qualificationOptions}
  onChange={selectedOption => {
    onQualificatioTypeChange({
      target: {
        name: 'qualificationType',
        value: selectedOption?.value || ''
      }
    });
  }}
  value={selectedQualification}
  placeholder={commonLabels.COMBO_SELECT}
  isClearable
  ref={inputRef}
/>

          </div>
          <div className='col-md-3'>
            <input
              type="text"
              className="form-control mt-4"
              name="qualificationNameToSearch"
              value={qualificationNameToSearch == false ? "" : qualificationNameToSearch}
              placeholder={masterLabels.qualificationNameList.BUTTON_SEARCH_PlaceHolder}
              onChange={event => { setQualificationNameToSearch(event.target.value); setSearchMode(false); }}
              maxLength="50"
            />
          </div>
          <div className='col-md-1'>
            <button
              className='form-control btn-primary button_search mt-4'
              onClick={() => { searchQualName(qualificationNameToSearch); }}
            ><i className="fa fa-search" type="button" ></i>
            </button>
          </div>
          <div className='col-md-2'></div>
          <div className='col-md-4 text-right col-lg-2 mt-4'>
            <button
              type="button"
              className=" btn btn-primary custom_button  btn-sm p-2  "
              onClick={() => { setAddQualificationName(true) }}
            >
              {masterLabels.qualificationNameList.Add_Qualification_Name_Btn}
            </button>
          </div>
        </div>
      </div>
      <br />

      <div className='form-group'>
        {qualificationNameListDetails && qualificationNameListDetails.totalNoOfrecords > 0 ?
          <div>
            <table className="table table-bordered">
              <thead className="thead-light">
                <tr>
                  <th scope="col" className='w-10 text-center'>{masterLabels.qualificationNameList.Tbl_No_Col}</th>
                  <th scope="col" className='w-20 text-left'>{masterLabels.qualificationNameList.Tbl_TypeCode_Col}</th>
                  <th scope="col" className='w-20 text-left'>{masterLabels.qualificationNameList.Tbl_NameCode_Col}</th>
                  <th scope="col" className='w-40 text-left'>{masterLabels.qualificationNameList.Tbl_Name_Col}</th>
                  <th scope="col" className='w-10 text-center'>{masterLabels.qualificationNameList.Tbl_Action_Col}</th>
                </tr>
              </thead>
              <tbody className='small'>
                {qualificationNameListDetails && qualificationNameListDetails.qualificationNameDtoList && qualificationNameListDetails.qualificationNameDtoList.map((element, index) => {
                  if (element) {
                    return (
                      <tr key={index}>
                        <td className="w-10 word-break text-center">{tableCounter++}</td>
                        <td className="word-break text-left">{element.qualificationTypeCode}</td>
                        <td className="word-break text-left">{element.qualificationNameCode}</td>
                        <td className="word-break text-left">{element.qualificationName}</td>
                        <td className="w-10 word-break text-center">
                          <i role="button" data-toggle="tooltip" title={commonLabels.BUTTON_EDIT} className='text-primary fa fa-edit' onClick={(e) => { setAddQualificationName(element.qualificationNameCode) }}></i>
                          &nbsp;&nbsp;
                          <i role="button" data-toggle="tooltip" title={element.isActive ? commonLabels.BUTTON_INACTIVE : commonLabels.BUTTON_ACTIVE}
                            className={element.isActive === true ? "text-success fa fa-toggle-on" : "text-danger fa fa-toggle-off"} onClick={(e) => { activeQualType(element.qualificationNameCode, element.isActive); }}></i>
                          &nbsp;&nbsp;
                          <i role="button" data-toggle="tooltip" title={commonLabels.BUTTON_DELETE} className='text-danger fa fa-trash' onClick={(e) => { manageQualType(element.qualificationNameCode, qualificationTypeCode); }}></i>
                        </td>
                      </tr>
                    )
                  }
                })
                }
              </tbody>
            </table>
            <TablePagination
              paginationFor="qualification_name_list"
              rowPerPage={rowPerPage}
              searchMode={searchMode}
              setListCurrentPage={setListCurrentPage}
              textToSearch={qualificationNameToSearch}
              searchCode2={qualificationTypeCode}
              totalCount={qualificationNameListDetails.totalNoOfrecords}
            />
          </div>
          :
          <div className='text-center'>
            <font className="text-danger">{qualificationTypeCode && commonLabels.NO_DATA_FOUND}</font>
          </div>
        }
      </div>
      {
        <ConfirmationDialog
          showModal={showModal}
          Title={commonLabels.CONFIRMATION_MODAL_TITLE}
          Message={commonLabels.CONFIRMATION_MESSAGE}
          setShowModal={setShowModal}
          deleteRecord={deleteQualType}
          deletedId={deleteQualificationName}
          IsConfirmation={"true"}
        />
      }
    </div>
  );
}

export default QualificationNameList;